// extracted by mini-css-extract-plugin
module.exports = {"container":"typewritingPanel_container__2QNxo"};